import { render, staticRenderFns } from "./LeadMaster.vue?vue&type=template&id=b5397bd2&"
import script from "./LeadMaster.vue?vue&type=script&lang=js&"
export * from "./LeadMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports